import { useEffect, useRef } from "react";

/**
 * Global mouse-position hook returning a Vector2-like ref in [-1..1] range.
 * Used by the 3D scene for a subtle parallax on the whole camera-rig.
 */
export default function useEarthAnimation() {
  const mouse = useRef({ x: 0, y: 0 });

  useEffect(() => {
    const onMove = (e) => {
      mouse.current.x = (e.clientX / window.innerWidth)  * 2 - 1;
      mouse.current.y = (e.clientY / window.innerHeight) * 2 - 1;
    };
    window.addEventListener("pointermove", onMove, { passive: true });
    return () => window.removeEventListener("pointermove", onMove);
  }, []);

  return mouse;
}
